import { createContext, useContext, useState, useEffect } from "react";
import { WindowHeight, WindowWidth } from "../utils/windowWidth";

const WindowDimensionsContext = createContext(undefined as any);

type ProviderWindowDimensionsT = {
  windowWidth: number,
  setWindowWidth: (width: number) => void
  windowHeight: number,
  setWindowHeight: (height: number) => void
  wWCheck: (number: number) => boolean
  wHCheck: (number: number) => boolean
}

export const useWindowDimensions = (): ProviderWindowDimensionsT => {
  return useContext(WindowDimensionsContext);
}

interface IProps {
  children: JSX.Element[] | JSX.Element;
}

const WindowDimensionsProvider = ({ children }: IProps) => {
  const [windowWidth, setWindowWidth] = useState(WindowWidth() as number);
  const [windowHeight, setWindowHeight] = useState(WindowHeight() as number);

  // Update window dimensions when resized
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Call once to set initial window size
    handleResize();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const wWCheck = (number: number) => {
    return windowWidth > number;
  }

  const wHCheck = (number: number) => {
    return windowHeight > number;
  }

  const value = {
    windowWidth,
    setWindowWidth,
    windowHeight,
    setWindowHeight,
    wWCheck,
    wHCheck
  }

  return (
      <WindowDimensionsContext.Provider value={value}>
        {children}
      </WindowDimensionsContext.Provider>
  );
}

export default WindowDimensionsProvider;